module.exports = __webpack_public_path__ + "img/image2.f1365a26.png";